<template>
  <el-tabs v-model="activeTab" type="card" :class="['children-tabs', isExpand && 'children-report-tabs']">
    <el-tab-pane v-for='child in children' :key="child.id" :label="child.name">
      <report-component v-if="child.report" :report='child.report' :external-filters="externalFilter(child.childrenReportColumnId,child.referenceReportColumnId)" :hasChildren="isChildren" :formRuntimeDialog="formRuntimeDialog" :isExpand="isExpand" :formDefinition="child.formDefinition"/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>

export default {
  name: 'children-tabs',
  props: ['defaultChildren', 'currentRow', 'formRuntimeDialog', 'isExpand'],
  inject: ['loadScript'],
  components: {
    ReportComponent: () => import('./report-component.vue')
  },
  data () {
    return {
      activeTab: '0',
      children: [],
      isChildren: true
    }
  },
  created () {
    this.loadReports()
  },

  methods: {
    async loadReport (reportId) {
      return (await this.$axios.get(`/report-api/report/definition/${reportId}?type=run`)).data
    },
    async getForm (formId) {
      return (await this.$axios.get(`/form-api/defines/${formId}`)).data
    },
    loadReports () {
      // 遍历所有子表, 加载报表定义信
      // eslint-disable-next-line no-return-await
      Promise.all(this.defaultChildren.map(async m => await this.loadReportItem(m))).then(res => {
        return new Promise(resolve => {
          res.forEach(r => this.children.push(r))
          resolve()
        })
      })
        .then(res => {
          // 找到所有有定制脚本的子表
          let hasJsChildren = this.children.filter(c => c.report && c.report.jsPath)
          if (hasJsChildren && hasJsChildren.length) {
            hasJsChildren.forEach(c => this.loadScript(c.report.jsPath, c.report.id))
          }
        })
        .catch(res => {
          throw new Error(res)
        })
    },
    async loadReportItem (report) {
      return new Promise(async (resolve, reject) => {
        try {
          let data = {
            ...report,
            // 子表
            report: null,
            formDefinition: null
          }
          // 加载子表
          let childReport = await this.loadReport(report.childrenReportId)
          let formDefinition = null
          if (report.columnEdit) {
            formDefinition = await this.getForm(childReport.editColumnForm)
          }
          childReport.mergeSame = childReport.mergeSame ? JSON.parse(childReport.mergeSame) : []
          childReport.filters && childReport.filters.forEach(n => {
            n.dataSource = JSON.parse(n.dataSource)
            n.template = JSON.parse(n.template)
          })
          data.report = childReport
          // 不知道为啥不直接处理完数据之后再push。。
          if (formDefinition) {
            data.formDefinition = formDefinition
          }
          resolve(data)
        } catch (e) {
          reject(e)
        }
      })
    },
    externalFilter (childrenReportColumnId, referenceReportColumnId) {
      // 子表的筛选条件为空的时候,会查询全部子表的数据,所以随便写个筛选提交
      let referenceReportValue = (this.currentRow && this.currentRow[referenceReportColumnId]) || '0.0abc'
      return [{[childrenReportColumnId]: referenceReportValue}, {'equals': childrenReportColumnId}]
    }
  },
  watch: {
    report (val) {
      if (val) {
        if (val.columnEdit) {
          this.$axios.get(`/form-api/defines/${val.editColumnForm}`).then(res => {
            this.formDefinition = res.data
          })
        }
      }
    }
  }
}
</script>
<style lang="scss">
  .children-report-tabs {
    height: 100%;
    .el-tabs__content {
      background-color: #fff;
      .el-tab-pane {
        width: 100%;
        height: 100%;
        background-color: #fff;
      }
    }
  }
  .children-tabs {
    .el-tabs__header {
      .el-tabs__item {
        height: 28px;
        line-height: 28px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/children-tabs.vue